import React from "react";
import { useNavigate } from "react-router-dom";
import { useBranding } from "../context/BrandingContext";

const VerifySuccessComponent = () => {
    const navigate = useNavigate();
    const { colors } = useBranding();

    const fullName = localStorage.getItem('_register_GRE_full_name')

    return (
        <main>
            <div className="verify-success">
                <div className="success-icon" style={{ background: colors?.buttonBg }}>
                    <div className="rounded-border" style={{ borderColor: "#fff" }}>
                        <svg
                            width="24px"
                            height="24px"
                            viewBox="0 0 29 29"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.5396 21.75L4.6521 14.8625L6.37397 13.1406L11.5396 18.3062L22.6261 7.21979L24.3479 8.94166L11.5396 21.75Z"
                                fill="#ffff"
                            />
                        </svg>
                    </div>
                </div>

                <h1>Registration Successful!</h1>

                <p className="message">
                    Welcome to GRE Ace, <span style={{ textTransform: "capitalize" }}>{fullName}</span>! Your account has been created and
                    your email is verified.
                </p>
                <p className="message" style={{ color: "#424242", fontWeight: 600 }}>
                    You're all set to start your GRE preparation journey.
                </p>

                <button onClick={() => {
                    localStorage.removeItem('_register_GRE_full_name')
                    navigate('/')
                }} className="btn-login-now btn dark" style={{ background: colors?.buttonBg }}>
                    Login Now
                </button>
            </div>
        </main>
    );
};

export default VerifySuccessComponent;
